import { render, staticRenderFns } from "./legalType.vue?vue&type=template&id=1f73a6c5"
import script from "./legalType.vue?vue&type=script&lang=js"
export * from "./legalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports